"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

// Traverse a Babel AST.
exports.default = function traverse(node, visitor) {
  visitor(node);
  for (var key in node) {
    if (key[0] === "_") continue;
    var val = node[key];
    if (val) {
      if (val.type) {
        traverse(val, visitor);
      } else if (Array.isArray(val)) {
        for (var _i2 = 0, _len2 = val.length; _i2 < _len2; _i2++) {
          var _e = val[_i2];

          traverse(_e, visitor);
        }
      }
    }
  }return undefined;
};